// extracted by mini-css-extract-plugin
export var borderRadius = "_al-4";
export var large = "_al-3";
export var logoContainer = "_al-0";
export var nameLogo = "_al-2";
export var small = "_al-1";